module.exports = __webpack_public_path__ + "img/紫外线.3fbcf28e.png";